// extracted by mini-css-extract-plugin
export default {"TeamMember":"TeamMember_TeamMember__hrJKw","TeamMember__memberName":"TeamMember_TeamMember__memberName__UCx5E","TeamMember__role":"TeamMember_TeamMember__role__UtE7m"};